import React from 'react';
import styles from './menu-bar.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import fileIcon from './icon--file.svg';
import {useIntl, FormattedMessage, defineMessage} from 'react-intl';
import MenuBarMenu from './menu-bar-menu.jsx';
import {MenuItem, MenuSection} from '../menu/menu.jsx';
import SB3Downloader from '../../containers/sb3-downloader.jsx';
import dropdownCaret from './dropdown-caret.svg';
import useMenuNavigation from '../../hooks/use-menu-navigation';

import sharedMessages from '../../lib/shared-messages';


const fileMenu = defineMessage({
    id: 'gui.aria.fileMenu',
    defaultMessage: 'File menu',
    description: 'accessibility label for file menu'
});

const openMenu = defineMessage({
    id: 'gui.aria.openMenu',
    defaultMessage: 'Open menu',
    description: 'accessibility label for open menu'
});


const SaveMenu = ({
    isRtl,
    onClickNew,
    getSaveToComputerHandler,
    therapyProjectState,
    depth,
    isCompany
}) => {
    const intl = useIntl();

    const {
        menuRef,
        isExpanded,
        handleKeyDown,
        handleKeyDownOpenMenu,
        handleOnOpen,
        handleOnClose
    } = useMenuNavigation({
        depth,
        isRtl
    });

    return (
        <button
            className={classNames(styles.menuBarItem, styles.hoverable, {
                [styles.active]: isExpanded()
            })}
            onClick={handleOnOpen}
            aria-label={intl.formatMessage(fileMenu)}
            aria-expanded={isExpanded()}
            ref={menuRef}
            onKeyDown={handleKeyDown}
        >
            <img src={fileIcon} />

       <span className={styles.collapsibleLabel}>
    Save
</span>

            <img src={dropdownCaret} />

            <MenuBarMenu
                className={classNames(styles.menuBarMenu)}
                open={isExpanded()}
                place={isRtl ? 'left' : 'right'}
                onRequestClose={handleOnClose}
            >
                <MenuSection>
                    <MenuItem
                        onClick={onClickNew}
                        isDataMenuItem
                        onParentKeyDown={handleKeyDownOpenMenu}
                    >
                        New
                    </MenuItem>
                </MenuSection>

                <MenuSection>
                    <SB3Downloader
                        therapyProjectState={therapyProjectState}
                    >
                        {(
                            className,
                            downloadProjectCallback,
                            saveToAlydCallback,
                            saveTherapyProjectCallback
                        ) => (
                            <React.Fragment>
                                <MenuItem
                                    className={className}
                                    onClick={getSaveToComputerHandler(
                                        downloadProjectCallback
                                    )}
                                    isDataMenuItem
                                    onParentKeyDown={handleKeyDownOpenMenu}
                                >
                                    Save to your computer
                                </MenuItem>

                                <MenuItem
                                    className={className}
                                    onClick={saveTherapyProjectCallback}
                                    isDataMenuItem
                                    onParentKeyDown={handleKeyDownOpenMenu}
                                >
                                    Save Therapy Project
                                </MenuItem>


                                {isCompany && (
                                    <MenuItem
                                        className={className}
                                        onClick={saveToAlydCallback}
                                        isDataMenuItem
                                        onParentKeyDown={handleKeyDownOpenMenu}
                                    >
                                        Save for Marketplace
                                    </MenuItem>
                                )}
                            </React.Fragment>
                        )}
                    </SB3Downloader>
                </MenuSection>
            </MenuBarMenu>
        </button>
    );
};


const OpenMenu = ({
    isRtl,
    onStartSelectingFileUpload,
    onRestoreTherapyProject,
    depth,
    isCompany
}) => {
    const intl = useIntl();

    const {
        menuRef,
        isExpanded,
        handleKeyDown,
        handleKeyDownOpenMenu,
        handleOnOpen,
        handleOnClose
    } = useMenuNavigation({
        depth,
        isRtl
    });
                                console.log("is company savemktplace", isCompany)

    return (
        <button
            className={classNames(styles.menuBarItem, styles.hoverable, {
                [styles.active]: isExpanded()
            })}
            onClick={handleOnOpen}
            aria-label={intl.formatMessage(openMenu)}
            aria-expanded={isExpanded()}
            ref={menuRef}
            onKeyDown={handleKeyDown}
        >
            <img src={fileIcon} />

            <span className={styles.collapsibleLabel}>
                Open
            </span>

            <img src={dropdownCaret} />

            <MenuBarMenu
                className={classNames(styles.menuBarMenu)}
                open={isExpanded()}
                place={isRtl ? 'left' : 'right'}
                onRequestClose={handleOnClose}
            >
                <MenuSection>
                    <MenuItem
                        onClick={onStartSelectingFileUpload}
                        isDataMenuItem
                        onParentKeyDown={handleKeyDownOpenMenu}
                    >
                        {intl.formatMessage(
                            sharedMessages.loadFromComputerTitle
                        )}
                    </MenuItem>
                </MenuSection>

                <MenuSection>
                    <SB3Downloader
                        onRestoreTherapyProject={onRestoreTherapyProject}
                    >
                        {(
                            className,
                            downloadProjectCallback,
                            saveToAlydCallback,
                            saveTherapyProjectCallback,
                            openTherapyProjectCallback,
                            openMarketplaceProjectCallback
                        ) => (
                            <React.Fragment>
                                <MenuItem
                                    className={className}
                                    onClick={openTherapyProjectCallback}
                                    isDataMenuItem
                                    onParentKeyDown={handleKeyDownOpenMenu}
                                >
                                    Open Therapy Project
                                </MenuItem>

                                {isCompany && (
                                    <MenuItem
                                        className={className}
                                        onClick={openMarketplaceProjectCallback}
                                        isDataMenuItem
                                        onParentKeyDown={handleKeyDownOpenMenu}
                                    >
                                        Open Marketplace Project
                                    </MenuItem>
                                  
  
)}
                       
                            </React.Fragment>
                        )}
                    </SB3Downloader>
                </MenuSection>
            </MenuBarMenu>
        </button>
    );
};


const FileMenu = props => (
    <React.Fragment>
        <SaveMenu
            isRtl={props.isRtl}
            onClickNew={props.onClickNew}
            getSaveToComputerHandler={props.getSaveToComputerHandler}
            depth={props.depth}
            therapyProjectState={props.therapyProjectState}
            isCompany={props.isCompany}
        />

        <OpenMenu
            isRtl={props.isRtl}
            onStartSelectingFileUpload={props.onStartSelectingFileUpload}
            depth={props.depth}
            onRestoreTherapyProject={props.onRestoreTherapyProject}
            isCompany={props.isCompany}
        />
    </React.Fragment>
);


SaveMenu.propTypes = {
    isRtl: PropTypes.bool,
    onClickNew: PropTypes.func.isRequired,
    getSaveToComputerHandler: PropTypes.func.isRequired,
    depth: PropTypes.number,
    therapyProjectState: PropTypes.object,
    isCompany: PropTypes.bool
};

OpenMenu.propTypes = {
    isRtl: PropTypes.bool,
    onStartSelectingFileUpload: PropTypes.func.isRequired,
    onRestoreTherapyProject: PropTypes.func,
    depth: PropTypes.number,
    isCompany: PropTypes.bool
};

FileMenu.propTypes = {
    isRtl: PropTypes.bool,
    onStartSelectingFileUpload: PropTypes.func.isRequired,
    onClickNew: PropTypes.func.isRequired,
    getSaveToComputerHandler: PropTypes.func.isRequired,
    depth: PropTypes.number,
    therapyProjectState: PropTypes.object,
    onRestoreTherapyProject: PropTypes.func,
    isCompany: PropTypes.bool
};


const mapStateToProps = state => ({
    isRtl: state.locales.isRtl
});


export default connect(
    mapStateToProps
)(FileMenu);